// block-代码块      ep-button
// element-元素     ep-button__icon
// modifier-修饰符  ep-button__icon--active
// state-状态      is-checked

function _bem(
  prefix: string,
  block: string,
  element: string,
  modifier: string,
) {
  if (block) {
    prefix += '-' + block
  }
  if (element) {
    prefix += '__' + element
  }
  if (modifier) {
    prefix += '--' + modifier
  }
  return prefix
}
function createBEM(prefix: string) {
  return {
    b: (block: string = '') => _bem(prefix, block, '', ''),
    e: (element: string = '') => (element ? _bem(prefix, '', element, '') : ''),
    m: (modifier: string = '') =>
      modifier ? _bem(prefix, '', '', modifier) : '',
    be: (block: string = '', element: string = '') =>
      block && element ? _bem(prefix, block, element, '') : '',
    bm: (block: string = '', modifier: string = '') =>
      block && modifier ? _bem(prefix, block, '', modifier) : '',
    em: (element: string = '', modifier: string = '') =>
      element && modifier ? _bem(prefix, '', element, modifier) : '',
    bem: (block: string = '', element: string = '', modifier: string) =>
      block && element && modifier
        ? _bem(prefix, block, element, modifier)
        : '',
    is: (name: string = '', state: boolean) => (state ? `is-${name}` : ''),
  }
}

export function createNameSpace(name) {
  const prefix = `ep-${name}`
  return createBEM(prefix)
}
